"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AnalyticsProvider;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactQuery = require("@tanstack/react-query");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultAnalyticsData = {};
function AnalyticsProvider(_ref) {
  var {
    children,
    initialAnalyticsData = defaultAnalyticsData,
    queryClient
  } = _ref;
  if (typeof window !== 'undefined') {
    defaultAnalyticsData = {
      browserTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: process.env.NODE_ENV === 'development' ? 'development' : 'production'
    };
  }
  (0, _react.useEffect)(() => {
    if (typeof window !== 'undefined') {
      window.analyticsData = _objectSpread(_objectSpread({}, window.analyticsData), initialAnalyticsData);
    }
  }, [initialAnalyticsData]);
  return (0, _jsxRuntime.jsx)(_reactQuery.QueryClientProvider, {
    client: queryClient,
    children: children
  });
}